import { useState } from "react";
import { Check, Copy } from "lucide-react";

import { Button, type ButtonProps } from "./button";

interface CopyButtonProps extends Omit<ButtonProps, "onClick" | "children"> {
  text: string;
  label?: string;
}

/**
 * Small button that copies a string to the clipboard and shows a
 * temporary confirmation. Used in section toolbars and on the kitchen-
 * sink showcase.
 */
export function CopyButton({ text, label = "Kopiraj", ...props }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  return (
    <Button
      variant="ghost"
      size="sm"
      {...props}
      onClick={(event) => {
        event.stopPropagation();
        void navigator.clipboard.writeText(text).then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 1500);
        });
      }}
    >
      {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
      {copied ? "Kopirano" : label}
    </Button>
  );
}
